let mostSearched = []
const items = process.env.REACT_APP_MOST_SEARCHED_ITEMS ? process.env.REACT_APP_MOST_SEARCHED_ITEMS.split(',') : []

items.map((i) => {
  mostSearched.push({ name: i })
})

export default mostSearched



// WEBPACK FOOTER //
// ./src/App/Header/Search/mostSearched.js